"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=()=>({padding:1.5});exports.root=o;
